<template>
<div>
    <div id="loaderoverlay" v-bind:style={display:onloader}>
        <div class="w-100 d-flex justify-content-center align-items-center">
            <div class="loaderspinner"></div>
        </div>
    </div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
        <router-link to="/dashboard" class="text-white pl-3">
            <i class="ni ni-tv-2"></i> Dashborad
        </router-link>    
        <span class="text-white"><i class="ni ni-bold-right"></i>Event</span>
    </base-header>

    <!--Charts-->
    <div class="container-fluid mt--7">
        <card header-classes="bg-transparent">
            <div v-if="openform">
                <div class="card bg-secondary border-0 mb-0">
                    <div class="card-body">
                        <div class="form-horizontal">
                            <form role="form" @submit.prevent="submitdata">
                                 <div class="row">
                                    <div class="col-md-12 pb-2">
                                        <img v-if="uploadedimage" height="100" :src="uploadedimage">
                                        <img v-else height="100" src="img/brand/empty.png"><br>                                 

                                        <input type="file" id="file" ref="file" class="inputfile inputfile-1" v-on:change="handleFileUpload()">                                               
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Event Title</label>
                                            <input v-model="EventTitleval" class="form-control" required>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Event Details</label>
                                            <textarea v-model="EventDetailsval" class="form-control" required></textarea>
                                            
                                        </div>
                                    </div>
                                        <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Event Date</label>
                                            <input v-model="EventDateval" type="date" class="form-control" required>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Event time</label>
                                            <input v-model="EventTimeval" type="time" class="form-control" required>
                                        </div>
                                    </div>                                                                             
                                </div>                                                              
                                <hr>
                                <div class="text-center mb-3">
                                    <button type="button" @click.stop="closeform()" class="btn btn-secondary">Cancel</button>
                                    <button type="submit" class="btn btn-primary my-4">Submit</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="form-inline">
                    <button type="button" @click.prevent="newterm" class="btn btn-default"><i class="ni ni-fat-add"></i>Add New </button>
                    <div class=" input-group">
                        <input v-model="searchval" class="form-control" @keyup="getsearch" placeholder="Search...">
                        <div class=" input-group-append">
                            <button type="button" @click.prevent="getsearch" class="btn btn-secondary"><i class="fa fa-search"></i> Search </button>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6" v-for="item in resultitems" :key="item.Id">
                        <div class="card bg-success">
                            <div class="card-body">
                                <img v-if="item.ImagePath" class="img-fluid" :src="$store.state.auth.baseurl + item.ImagePath.substr(1)" alt="" height="30">
                                <img v-else src="img/brand/empty.png" class="img-fluid" alt="" height="30" />
                                <h3 class="text-white">{{item.EventTitle}}</h3>
                                <p class="text-white">{{item.EventDetails}}</p>
                                <h5 class="text-right text-white"><span class="badge">{{item.EventDate | formatDate}}</span> <span class="badge">{{item.EventTime}}</span> </h5>
                                <div class="card-footer text-center">
                                    <button class="btn btn-secondary btn-sm my-2" v-on:click="edititem(item.Id)"><i class="fa fa-edit"></i> Edit</button> 
                                </div>
                            </div>
                        </div>
                        
                    </div>                                  
                </div>
            </div>
        </card>
    </div>
</div>
</template>

<script>
import moment from 'moment'
import swal from 'sweetalert'
export default {   
    name: 'Event',
    data() {
        return {
            Idval: 1,           
            EventTitleval: '',
            EventDetailsval: '',
            EventDateval: null,
            EventTimeval: null,
            ImagePathval: '',           
            resultitems:null,          
            file: '',
            uploadedimage: '',
            searchval: '',
            process: 'N',
            openform: false,           
            onloader: 'none'
        }
    },     
    methods: {
        newterm: function () {
            this.EventTitleval= '';
            this.EventDetailsval= '';
            this.EventDateval= null;
            this.EventTimeval= null;                     
            this.ImagePathval= '';                 
            this.file = '';
            this.uploadedimage = '';           
            this.openform = true;
            this.process = 'N';            
        },
        closeform: function () {
            this.EventTitleval= '';
            this.EventDetailsval= '';
            this.EventDateval= null;
            this.EventTimeval= null;                     
            this.ImagePathval= '';                 
            this.file = '';
            this.uploadedimage = '';             
            this.file = '';
            this.uploadedimage = '';
            this.openform = false;
            this.process = 'N';           
        },         
        edititem: function (Id) {
            this.onloader = 'flex'
            this.$store.dispatch('geteventbyid', Id)
                .then(resp => {                   
                    this.Idval = resp.Id;                   
                    if (resp.ImagePath != null) {
                        this.uploadedimage = this.$store.state.auth.baseurl + resp.ImagePath.substr(1);
                    }
                    this.EventTitleval= resp.EventTitle;
                    this.EventDetailsval= resp.EventDetails;
                    this.EventDateval= this.frontEndDateFormat(resp.EventDate);
                    this.EventTimeval= resp.EventTime;                     
                    this.ImagePathval= resp.ImagePath;                                      
                    this.openform = true;
                    this.process = 'U';
                    this.onloader = 'none';
                })
                .catch(err => {
                    this.onloader = 'none'
                    this.checkresponse(err.response.data);
                })
        },     
        submitdata: function () {
            let Id = this.Idval;
            let EventTitle = this.EventTitleval;
            let EventDetails= this.EventDetailsval;
            let EventDate= this.EventDateval;
            let EventTime = this.EventTimeval;
            let ImagePath = this.ImagePathval;            
            let Operation = this.process;
            let Username = this.$store.state.auth.token;         
            this.onloader = 'flex';
            let userdata={Id, EventTitle, EventDetails, EventDate, EventTime, ImagePath, Operation, Username}           
            this.$store.dispatch('processevent', userdata)
                .then((resp) => {
                    this.resultitems = resp;
                    this.closeform();
                    this.onloader = 'none'
                    swal({
                        title: "Success!",
                        text: 'Submitted successfully',
                        icon: "success",
                        button: "Ok",
                    });
                })
                .catch(err => {
                    this.onloader = 'none'
                    this.checkresponse(err.response.data);
                })
        },
        getevent: function () {
            this.onloader = 'flex'
            this.$store.dispatch('getevent')
                .then((resp) => {
                    this.resultitems = resp;
                    this.onloader = 'none'
                })
                .catch(err => {
                    this.onloader = 'none'
                    this.checkresponse(err.response.data);
                })
        },
        getsearch: function () {
            this.$store.dispatch('geteventbysearch', this.searchval)
                .then((resp) => {
                    this.resultitems = resp;
                    //console.log(resp)
                })
                .catch(err => {
                    this.checkresponse(err.response.data);
                })
        }, 
        handleFileUpload: function () {
            this.file = this.$refs.file.files[0];
            this.submitFile();
        },
        submitFile: function () {
            this.onloader = 'flex'
            var form = new FormData();
            let username = this.$store.state.auth.token;          
            let formalurl = this.ImagePathval;
            let doctype = 'image';
            form.append('username', username)          
            form.append('formalurl', formalurl)
            form.append('doctype', doctype)
            form.append('file', this.file)
            this.$store.dispatch('uploadfile', form)
                .then((resp) => {
                    this.ImagePathval = resp;
                    this.uploadedimage = this.$store.state.auth.baseurl + resp.substr(1)
                    this.onloader = 'none'
                    swal({
                        title: "Success!",
                        text: 'Uploaded successfully',
                        icon: "success",
                        button: "Ok",
                    });
                })
                .catch(err => {
                    this.onloader = 'none'
                    this.checkresponse(err.response.data);
                })
        },
        frontEndDateFormat: function (date) {
            return moment(date).format('YYYY-MM-DD');
        },
        backEndDateFormat: function (date) {
            return moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
        },
        checkresponse: function (resp) {
            if (resp === "Access Expired" || resp === "Invalid Credential") {
                this.$store.dispatch('logout');
                this.$router.push('/login')
            } else {
                console.log(resp);
                swal({
                        title: "Oops!",
                        text: resp.response.data,
                        icon: "error",
                        button: "Ok",
                    });
            }
        }

    },
    mounted() {
        if (this.$store.state.auth.user_status_id != 2) {
            this.$store.dispatch('logout')
            this.$router.push('/login')
        } else { 
               
            this.getevent();           
        }

    }
};
</script>

<style>

</style>
